module.exports = __webpack_public_path__ + "static/media/Chapman.ccf86051.jpg";